/** Types de champ possibles pour afficher un composant graphique correspondant à ce type pour les formulaires générés dynamiquement */
enum FieldTypeEnum {
	Text,
	Number,
	// Email,
	// Password,
	// Search,
	// Url,
	// Tel,
	Date,
	// Time,
	// Range,
	// Color,
	/** Zone de saisie plus large. A utiliser pour les champs description */
	TextArea,
	/** Boutons radio (un seul choix possible) */
	OptionList,
	/** Checkbox (choix multiples) */
	CheckList,
	/** Liste (un seul choix possible) */
	SelectList,
	/** Liste (plusieurs choix possibles) */
	MultiSelectList,
	/** Tableau */
	Table,
	/** Image */
	Image,
	/** Noeud de graphique */
	Node,
	/** Liaison de graphique */
	Edge,
	/** Note */
	Mark
}

export default FieldTypeEnum;